/**
 * Created by Ning Jiang on 12/6/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {ReelAttentionView} from "./ReelAttentionView";

export class ReelAttentionController extends ReelStopPresentationController {

    private _view:ReelAttentionView;
    private _nearWinStates:boolean[];
    private _nearWinData:boolean[];
    private _respinTriggered:boolean;
    private _freespinTriggered:boolean;
    private _superFreespinTrigered:boolean;

    constructor(index:number) {
        super(index, "reelAttention");

        this._view = new ReelAttentionView();
        this._nearWinStates = ArrayHelper.initArrayWithValues(5, (index:number) => false);
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {

        // TODO: Remove near win server data: _nearWinData

        this._nearWinData = data.nearWinClientReels;
        this._respinTriggered = data.bonusTriggeredThisSpin;
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._superFreespinTrigered = data.superFreespinTriggeredThisSpin;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onReelNearWin(event.params[0]));
    }

    private onReelNearWin(reelId:number):void {
        this._nearWinStates[reelId] = true;
        this._view.playNearWin(reelId);

        SlotGame.sound.playEffect(this.getSoundName(reelId));
    }

    private getSoundName(reelId:number):string {
        switch(reelId) {
            case 3:
                return TombstoneSoundConfig.instance.ANTICIPATION_REEL3;
            case 4:
                return TombstoneSoundConfig.instance.ANTICIPATION_REEL4;
            default:
                debugger;
                Logger.logDev(`ReelAttentionController.getSoundName():Wrong reelId ${reelId}`);
                return TombstoneSoundConfig.instance.ANTICIPATION_REEL4;
        }
    }

    private playFailSound():void {
        SlotGame.sound.playEffect(TombstoneSoundConfig.instance.ANTICIPATION_FAIL);
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._nearWinStates[data.reelId]) {
            this._nearWinStates[data.reelId] = false;
            this._view.stopNearWin(data.reelId);

            // Do not play failed sound for big win near win.
            if(this._nearWinData[data.reelId]) {
                if(data.reelId === 3 && !this._freespinTriggered && !this._nearWinData[4]) {
                    this.playFailSound();
                }
                if(data.reelId === 4 && !this._respinTriggered && !this._superFreespinTrigered) {
                    this.playFailSound();
                }
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.quickStop && data.reelId === 4) {
            SlotGame.sound.stopEffect(TombstoneSoundConfig.instance.ANTICIPATION_REEL3, 100);
            SlotGame.sound.stopEffect(TombstoneSoundConfig.instance.ANTICIPATION_REEL4, 100);
        }
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    protected resetFeature():void {
        this._view.reset();
    }
}